/**
 * @module nativeAPI_コンポーネント
 */
/* nativeAPI.js */
// Native部に送るAPI群を定義

const urlScheme = 'alsok-hsapp-prv';

/********************
	関数宣言
********************/

/**
 * URLエンコードを行う関数
 * @param {string} api
 * @param {string} queryName
 * @param {string} value
 * @return {string} api
 */
function addQueryParameter(api, queryName, value) {
  if (api.slice(-1) != '?') {
    api += '&';
  }
  api += queryName + '=' + encodeURIComponent(String(value)); // エンコードしてから渡す
  return api;
}

/**
 * apiをNativeに渡す関数
 * @param {string} api
 * @return なし
 */
function executeAPI(api) {
  location.href = api;
  // console.log("Request=" + api);
}

/********************
	IF01.アカウント情報記録
********************/
/**
 * アカウント情報を記録する関数
 * @param {string} userId
 * @param {string} password
 * @param {string} terminalInfo
 * @return なし
 */
function registerAccountInfo(userId, password, terminalInfo) {
  var api = urlScheme + '://registerAccountInfo?';

  if (userId != null) {
    api = addQueryParameter(api, 'userId', userId);
  }
  if (password != null) {
    api = addQueryParameter(api, 'password', password);
  }
  if (terminalInfo != null) {
    api = addQueryParameter(api, 'terminalInfo', terminalInfo);
  }

  executeAPI(api);
}

/********************
	IF02.ログイン設定記録
********************/
/**
 * ログイン設定を記録する関数
 * @param {int} loginMethod
 * @param {string} passcode01
 * @param {string} passcode02
 * @return なし
 */
function registerLoginSetting(loginMethod, passcode01, passcode02) {
  var api = urlScheme + '://registerLoginSetting?';

  if (loginMethod != null) {
    api = addQueryParameter(api, 'loginMethod', loginMethod);
  }
  if (passcode01 != null) {
    api = addQueryParameter(api, 'passcode01', passcode01);
  }
  if (passcode02 != null) {
    api = addQueryParameter(api, 'passcode02', passcode02);
  }

  executeAPI(api);
}

/********************
	IF03.設定アプリ表示要求
********************/
/**
 * 設定アプリを表示要求する関数
 * @param {int} targetPage
 * @return なし
 */
function openSettingApp(targetPage) {
  var api = urlScheme + '://openSettingApp?';

  if (targetPage != null) {
    api = addQueryParameter(api, 'targetPage', targetPage);
  }

  executeAPI(api);
}

/********************
	IF04.アプリNative部保持情報要求
********************/
/**
 * アプリNative部の保持情報を要求する関数
 * @return なし
 */
function requestNativeAppInfo() {
  var api = urlScheme + '://requestNativeAppInfo?';

  executeAPI(api);
}

/********************
	IF05.アカウント情報要求
********************/
/**
 * アカウント情報を要求する関数
 * @param {int} requestPassword
 * @return なし
 */
function requestAccountInfo(requestPassword) {
  var api = urlScheme + '://requestAccountInfo?';

  if (requestPassword != null) {
    api = addQueryParameter(api, 'requestPassword', requestPassword);
  }

  executeAPI(api);
}

/********************
	IF06.生体認証要求
********************/
/**
 * 生体認証を要求する関数
 * @return なし
 */
function requestBiometricAuth() {
  var api = urlScheme + '://requestBiometricAuth?';

  executeAPI(api);
}

/********************
	IF07.パスコード認証要求
********************/
/**
 * パスコード認証を要求する関数
 * @param {string} passcode
 * @return なし
 */
function requestPasscodeAuth(passcode) {
  var api = urlScheme + '://requestPasscodeAuth?';

  if (passcode != null) {
    api = addQueryParameter(api, 'passcode', passcode);
  }

  executeAPI(api);
}

/********************
	IF08.スプラッシュ画面Close
********************/
/**
 * スプラッシュ画面をCloseする関数
 * @return なし
 */
function closeSplash() {
  var api = urlScheme + '://closeSplash?';

  executeAPI(api);
}

/********************
	IF09.言語設定記録
********************/
/**
 * 言語設定を記録する関数
 * @param {string} langCode
 * @return なし
 */
function registerLanguageSetting(langCode) {
  var api = urlScheme + '://registerLanguageSetting?';

  if (langCode != null) {
    api = addQueryParameter(api, 'langCode', langCode);
  }

  executeAPI(api);
}

/********************
	IF10.アプリNative部エラー
********************/
/**
 * アプリNativeの電話アプリ・メールアプリ・ブラウザを開く関数IF10
 * @return なし
 */
function openBrowserApp(url) {
  // 外部ブラウザを開く際は、IF12を用いる。
  // ブラウザアプリが全てアンインストールされていた場合は、
  // 空文字から外部アプリを起動するなどして、エラーを発生させて、
  // コールバックonOpenExternalAppFinishedでエラーをWebUIに返す
  openExternalApp(url, '');
}

function openExternalBrowserWithToken(url) {
  openExternalApp(url, '', true);
}

function openTelApp(telNumber) {
  var api = 'tel:' + telNumber;

  executeAPI(api);
}

function openMailApp(url) {
  executeAPI(url);
}

/********************
	IF11.アプリNativeライフサイクルイベント通知
********************/
/**
 * アプリNative部ライフサイクルイベント通知を返す関数
 * @return なし
 */
function appLifeCycleStateChanged() {
  var api = urlScheme + '://appLifeCycleStateChanged?';

  executeAPI(api);
}

/********************
	IF12.外部アプリケーション起動要求
********************/
/**
 * アプリNative部に外部アプリケーションの起動を要求する関数
 * @return なし
 */
function openExternalApp(deepLinkUrl, storeUrl, hasToken = false) {
  let url = '';
  if (hasToken) {
    // Setup for management manipulation in external browser
    url = deepLinkUrl + '?takeoverToken=' + sessionStorage.getItem('takeoverToken');
  } else {
    url = deepLinkUrl;
  }

  location.href = url;
  var api = urlScheme + '://openExternalApp?';

  if (deepLinkUrl != null) {
    api = addQueryParameter(api, 'deepLinkUrl', url);
  }
  if (storeUrl != null) {
    api = addQueryParameter(api, 'storeUrl', storeUrl);
  }

  executeAPI(api);
}

export default {
  registerAccountInfo,
  registerLoginSetting,
  openSettingApp,
  requestNativeAppInfo,
  requestAccountInfo,
  requestBiometricAuth,
  requestPasscodeAuth,
  closeSplash,
  registerLanguageSetting,
  openBrowserApp,
  openTelApp,
  openMailApp,
  appLifeCycleStateChanged,
  openExternalApp,
  openExternalBrowserWithToken,
};
